import React, { useMemo } from 'react';
import Image from 'next/image';
import style from './TwitterShareButton.module.scss';

const ICON_SIZE = 16;

export const TWITTER_URL = 'https://twitter.com/intent/tweet';

export const generateTwitterIntentUrl = ({
  currentUrl,
  title,
}: {
  currentUrl: string;
  hashtags?: Array<string>;
  title: string;
}) => {
  const intentSearchParams = new URLSearchParams();
  intentSearchParams.append('url', encodeURI(currentUrl));
  // twitter appends the url to the tweet. Tweet characters are scarce so remove this
  // url from the text if it exists
  const textWithoutUrl = title.replace(currentUrl, '');
  intentSearchParams.append('text', textWithoutUrl);
  return `${TWITTER_URL}?${intentSearchParams.toString()}`;
};

interface Props {
  fullUrl: string;
  title: string;
}

const TwitterShareButton: React.FC<Props> = ({ fullUrl, title }) => {
  const { twitterUrl } = useMemo(() => {
    if (fullUrl.length > 0 && title) {
      const fullUrlAsURL = new URL(fullUrl);
      const { href } = fullUrlAsURL;
      return {
        twitterUrl: generateTwitterIntentUrl({ currentUrl: href, title }),
      };
    }

    return { twitterUrl: '' };
  }, [fullUrl, title]);

  return (
    <div className={style.container}>
      <a className={style.button} href={twitterUrl} target="_blank" rel="noreferrer">
        <div className={style['icon-container']}>
          <Image
            alt="Twitter"
            src="/static/images/social/twitter_icon.svg"
            width={ICON_SIZE}
            height={ICON_SIZE}
          />
        </div>
        <span className={style.text}>ツイート</span>
      </a>
    </div>
  );
};

export default TwitterShareButton;
